import { FunctionComponent } from "react";
import { Alert, Box, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MANAGEMENT_FLOOR_PLAN_SVG_HEIGHT_DESKTOP } from "../utils/management-toolbar.constants";
import {
  ManagementCompareSelects,
  type ManagementCompareSelectsProps
} from "./ManagementCompareSelects";

type ManagementFloorCompareSlotProps = ManagementCompareSelectsProps;

/**
 * Empty half of the floor-plan row: pick compare location + floor.
 * After a floor is selected, the toolbar row takes over editing.
 */
export const ManagementFloorCompareSlot: FunctionComponent<ManagementFloorCompareSlotProps> = ({
  ...selectProps
}) => {
  const { t } = useTranslation();

  return (
    <Box
      data-testid="management-floor-compare-slot"
      sx={{
        height: "100%",
        minHeight: MANAGEMENT_FLOOR_PLAN_SVG_HEIGHT_DESKTOP,
        border: theme => `1px solid ${theme.palette.divider}`,
        borderRadius: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2
      }}
    >
      <Stack spacing={2} sx={{ width: "100%", maxWidth: 360 }}>
        <Alert severity="info">{t("_management_compareWith")}</Alert>
        <ManagementCompareSelects {...selectProps} />
      </Stack>
    </Box>
  );
};
